module.exports = __webpack_public_path__ + "static/img/1.6f86a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/1.png
// module id = 93zg
// module chunks = 0